import React from 'react';
import { useTranslation } from 'react-i18next';

export function BorderColorConfig({ obj, handleBorder }) {
  const { t } = useTranslation('common');
  return (
    <div className="pl-0 pr-2">
      <p className="mb-2 f-14 text-bold">{t('CUSTOM_MODULE.COLOR')}</p>
      <div className="border-color-container">
        <input type="color" id="border_color" onChange={handleBorder} value={obj?.otherConfiguration?.border_color || '#848484'} name="border_color" />
      </div>
    </div>
  );
}

export default BorderColorConfig;
